import { api } from "constants/RotasAPI";
import usePost from "hooks/usePost";
import { toast } from "react-hot-toast";
import { getMensagemDeErroBackend } from "shared/util/functions/errors/GetMensagemDeErroBackend";
import { possuiMensagemDeErro } from "shared/util/functions/errors/RequestPossuiMensagemDeErro";

export const usePostCriarContaDigitalPendente = (onSuccessFunction: Function) => {
  const onSuccess = () => {
    toast.success("Conta digital solicitada com sucesso!");
    onSuccessFunction();
  };

  const onError = (erro: any) => {
    possuiMensagemDeErro(erro)
      ? toast.error(getMensagemDeErroBackend(erro))
      : toast.error("Erro ao criar conta digital");
  };

  return usePost<unknown>({
    url: api.contaDigital.postCriarContaDigitalGroupCondominios,
    onSuccess,
    onError,
  });
};
